<template>
    <div id="choiceNavigation" class="tabs">
      <router-link class="tab" :to="{ path: '/choice-items', query: query }">{{$t("inventory.choice_items")}}</router-link>
      <router-link class="tab" :to="{ path: '/choices', query: query }">{{$t("inventory.choices")}}</router-link>
      <router-link class="tab" :to="{ path: '/choice-groups', query: query }">{{$t("inventory.choice_groups")}}</router-link>
    </div>
</template>

<script>

  export default {
    name: "choiceNavigation",

    data() {
      return {
        query: {
          branch: this.$route.query.branch,
          company: this.$route.query.company ? this.$route.query.company : undefined
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
    .tab {
        cursor: pointer;
    }
</style>